/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: CustomersAddComponent
 * Purpose		: This component allows to create new Customers record and save changes.
 * Dependency	: CustomersService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, OnInit,
	HostBinding, trigger, transition, animate,
	style, state } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/switchMap';
import { ToastsManager }  from 'ng2-toastr';

import { CustomersData, CustomersService } from './Customers.service';


@Component({
	selector: 'my-Customers-add',
	template: require('./CustomersAdd.component.html'),
	providers: [CustomersService
		
		],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.2s ease-in')
      ]),
      transition(':leave', [
        animate('0.5s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class CustomersAddComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}

	// @HostBinding('style.position') get position() {
	//  return 'absolute';
	// }

	objCustomers: CustomersData;
	errorMessage: string;
	messages: string[];

	// Lookup Arrays
	

  constructor(
    private route: ActivatedRoute,
    private router: Router,
	private toastr: ToastsManager,
    private CustomersService: CustomersService

	) {
		this.objCustomers = new CustomersData();
	}

	ngOnInit() {
		this.objCustomers = new CustomersData();
		this.getLookups();
	}

	addCustomers() {
		this.CustomersService.addCustomersData(this.objCustomers)
			.subscribe(record => this.router.navigate(['/Customers']),
			error =>  this.errorMessage = 'There was an error while adding record. Error: ' + <any>error,
			() => { 
				this.toastr.success('Customers record added successfully...', 'Add Customers');
				console.log('Customers record added successfully...'); 
			}
		);
	}

	gotoCustomers() {
		// let Id = this.objCustomers ? this.objCustomers.CustomerID : null;
		this.router.navigate(['/Customers']);
	}


	getLookups() {

	}

	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/Customers/CustomersAdd.component.ts